// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mainNavigationItemStyles } from "@eisinc/Overrides/Components/MainNavigationItem";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

mainNavigationItemStyles.popup = {
    css: css`
        padding: 24px 0 30px;
    `,
};

mainNavigationItemStyles.container = {
    as: "div",
    fullWidth: [true, true, false, false, false],
    padding: 0,
    background: "transparent",
    css: css`
        height: 50vh;
        display: flex;
    `,
};

mainNavigationItemStyles.firstLevel = {
    css: css`
        border-right: 1px solid ${color("common.ui1")};
        width: 340px;
        min-width: 340px;
        height: 100%;
    `,
};

mainNavigationItemStyles.itemLink = {
    css: css`
        position: relative;
        width: 100%;
        padding: 10px 15px;
        font-size: ${fontConfig.small.size}px;
        line-height: ${fontConfig.singleLineSmall.lineHeight};
        transition: background-color 200ms ease;
        span {
            color: ${color("text.main")} !important;
        }
        &:hover {
            background-color: ${color("common.ui2")};
            text-decoration: none;
            span,
            p {
                text-decoration: none !important;
                color: ${color("text.main")} !important;
            }
        }
    `,
};

mainNavigationItemStyles.menuItemIcon = {
    css: css`
        position: absolute;
        right: 10px;
        top: 12px;
        margin: -3px 0 0 10px;
    `,
    size: 18,
    color: "secondary.contrast",
};
